export default "__VITE_ASSET__C$u2kuir__"